import { MenuItemData, isMenuItemLink } from '../menu-item-data'
import { SubmenuItem } from './submenu-item'
import { SubmenuList, SubmenuListWrapper } from './styled'
import { useMenuContext } from '../hooks/use-menu-context'
import { useSubmenu } from '../hooks/use-submenu'

type SubmenuProps = {
  menuItem: MenuItemData
}

export const Submenu = ({ menuItem }: SubmenuProps): JSX.Element | null => {
  const { selected } = useMenuContext()
  const [itemsRefs] = useSubmenu({ item: menuItem })
  if (isMenuItemLink(menuItem)) {
    return null
  }
  return (
    <SubmenuList
      id={`menu-${menuItem.label}`}
      role="menu"
      hidden={selected !== menuItem}
      isDense={menuItem.isDense}
    >
      <SubmenuListWrapper columns={menuItem.columns} isDense={menuItem.isDense}>
        {menuItem.submenuItems.filter(isMenuItemLink).map((item, index) => (
          <SubmenuItem
            colSpan={item.fullWidth ? menuItem.columns : undefined}
            ref={el => (itemsRefs.current[index] = el)}
            key={`submenu-item-${index}`}
            item={item}
          />
        ))}
      </SubmenuListWrapper>
    </SubmenuList>
  )
}
